export default "__VITE_ASSET__I8B_5p6t__"